import { render, staticRenderFns } from "./CarFront.vue?vue&type=template&id=61e517b8&scoped=true&"
import script from "./CarFront.vue?vue&type=script&lang=ts&"
export * from "./CarFront.vue?vue&type=script&lang=ts&"
import style0 from "./CarFront.vue?vue&type=style&index=0&id=61e517b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e517b8",
  null
  
)

export default component.exports